//Below are URL endpoints for API calls
export const endPoints = {
  getJoinDetails: "get_join_details",
  getUserMeetingStatus: "get_user_meeting",
  markAttendance: "post_meeting_attendees",
  getUser: "get_user",
  addUser: "add_user",
  updateMeetingRegistration: "update_meeting_registration",
  faceLogin: "auth_login",
  updateUser: "update_user",
  formSection: "form-section",
  getUserMemebersList: "get_user_member_list",
  getUsers: "get_users",
  updateUserMember: "manage_user_member",
  meetingAttendees: "meeting/attendees",
  deleteSeekerAccount: "delete_infini_user",
  /**Admin API endpoints */
  getAdminMeetingData: "get_admin_meeting",
  getRegisteredUsersForWebinar: "users/webinar",
  createMeeting: "create_meeting",
  addMembersAttendance: (userId: number) => `users/${userId}/members`,
  /* New Auth endpoints */
  login: "auth/login",
  validateOTP: "auth/validate-otp",
  resendOTP: "auth/resend-otp",
  logout: "auth/logout",

  appConfigurations: "appConfig",
  awsFileUploadUrl: "aws/file-upload",
  searchFace: "search-face-in-collection",
  compareFace: "compare-two-faces",
  /**Refactored version end points */
  users: "users",
  user: "user",
  admin: "admins",
  webinars: "webinars",
  completedWebinars: "completed-webinars",
  faceLoginV1: "login",
  getUserMembers: (userId: number, page: number, size: number) =>
    `users/${userId}/members?page=${page}&size=${size}`,
  uploadFileAws: "upload-file",
  uploadFileToRegistrations: "upload-auto-registration",
  autoRegisterSeekers: "auto-register-seekers",
  validateautoregisterexcel: "validate-auto-register-excel",
  analyticsSeekerDetails: "/admin/session-analytics/seeker-details",
  sessionAnalytics: "/admin/session-analytics",
  sessions: "/admin/sessions",
  bulkRegistration: "bulk-registration",
  bulkRegistrationsUploadSuccess: "process-bulk-registration",
  completedWebinarsList: "list-completed-webinars", // api endpoint
  aggregateSeekerDetails: "/admin/aggregate-analytics/seeker-details",
  aggregateAnaltyics: "/admin/aggregate-analytics",
  seekerAnalytics: "/admin/seekers-analytics",
  getAggregateAnalytics: (
    programSessionId: number,
    programTypeId: number,
    programId: number,
  ) =>
    `analytics?programSessionId=[${programSessionId}]&programTypeId=${programTypeId}&programId=${programId}`,
  analyticsUsers: (userId: string, limit = 0, offset = 0, filters = "") =>
    `analytics-users?userIds=${userId}&limit=${limit}&offset=${offset}&filters=${filters}`, //api endpoint
  question: "question",
  option: "option",
  category: "option-category",
  questionOption: "question-option",
  aggregateWebinarsList: "webinars-list",
  programType: "program-type",
  program: "program",
  generateform: "form-schema/generate",
  programQuestion: "program-question",
  getRegistrationQuestionsById: (id: string) => `registration/${id}/questions`,
  programRegistration: "registration",

  RegisteredSeekersList: "registration",
  seekerData: (userId: number) => `user/${userId}/registrations`,
  adminPrograms: "registration",
  getProgramEndPoint: (filter: any) =>
    `program?limit=100&filters=${encodeURIComponent(JSON.stringify(filter))}`,
  paymentWebhook: "payment/portal-webhook",
  invoiceDownload: (id: number) => `invoice/download/${id}`,
  proformaDownload: (id: string) => `invoice/proforma/download/${id}`,
  fileUpload: "aws/file-upload",
  getEntrainmentRegistrations: `get-user-registrations`,
  getEntrainmentSeatsStatus: (id: number) => `program/${id}`,
  locationNavigation: "https://maps.app.goo.gl/4rq53HoDq44LcgRi6",
  extractData: "extract-details",
  downloadInvoice: (id: number) => `invoice-download/${id}`,
};

export const DummyJSON = {
  success: true,
  formData: [
    {
      formTitle: "Program Registration Form",
      formId: "",
      sections: [
        {
          id: "basicDetails",
          title: "Basic Details",
          fields: [
            {
              id: "fullName",
              label: "Full Name",
              isDisabled: false,
              isMultiple: false,
              required: true,
              validation: {
                pattern: "^[a-zA-Z\\s]{5,50}$",
                message: "Please enter a valid name (2-50 characters)",
              },
              placeholder: "Enter your full name",
              showWhen: null,
              type: "text",
            },
            {
              id: "gender",
              label: "Select Gender",
              isDisabled: false,
              isMultiple: true,
              required: true,
              validation: null,
              options: [
                { value: "male", label: "Male" },
                { value: "female", label: "Female" },
                { value: "other", label: "Other" },
              ],
              showWhen: null,
              type: "radio",
            },
            {
              id: "mobileNumber",
              label: "Mobile Number",
              type: "tel",
              placeholder: "Enter your mobile number",
              required: true,
              validation: {
                pattern: "^[0-9]{10}$",
                message: "Please enter a valid 10-digit mobile number",
              },
              isDisabled: false,
              isMultiple: false,
              showWhen: null,
            },
            {
              id: "email",
              label: "Email Address",
              type: "email",
              placeholder: "Enter your email address",
              required: true,
              validation: {
                pattern: "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$",
                message: "Please enter a valid email address",
              },
              isDisabled: false,
              isMultiple: false,
              showWhen: null,
            },
            {
              id: "dob",
              label: "Date of Birth",
              type: "date",
              required: true,
              validation: {
                minAge: 3,
                maxAge: 100,
                message: "Age must be between 3 and 100 years",
              },
              isDisabled: false,
              isMultiple: false,
              showWhen: null,
            },
            {
              id: "infinitheismContact",
              label: "Infinitheism Contact",
              type: "text",
              placeholder: "Your Infinitheism contact person",
              required: false,
              isDisabled: false,
              isMultiple: false,
              validation: null,
              showWhen: null,
            },
            {
              id: "city",
              label: "City",
              type: "text",
              placeholder: "Enter your city",
              required: true,
              isDisabled: false,
              isMultiple: false,
              validation: null,
              showWhen: null,
            },
            {
              id: "preferredRoommate",
              label: "Preferred Roommate's Name",
              type: "text",
              placeholder: "Enter preferred roommate (if any)",
              required: false,
              isDisabled: false,
              isMultiple: false,
              validation: null,
              showWhen: null,
            },
            {
              id: "notes",
              label: "Notes",
              isDisabled: false,
              required: false,
              placeholder: "Any additional information or requests",
              rows: 3,
              type: "textarea",
              isMultiple: false,
              validation: null,
              showWhen: null,
            },
            {
              id: "termsAccepted",
              label: "I accept the Terms & Conditions",
              type: "checkbox",
              required: true,
              isDisabled: false,
              isMultiple: false,
              validation: null,
              showWhen: null,
            },
          ],
        },
        {
          id: "travelDetails",
          title: "Travel Details",
          fields: [
            {
              id: "idType",
              label: "ID Type",
              type: "select",
              required: true,
              options: [
                { value: "passport", label: "Passport" },
                { value: "drivingLicense", label: "Driving License" },
                { value: "aadhaar", label: "Aadhaar Card" },
                { value: "voterID", label: "Voter ID" },
              ],
              isDisabled: false,
              isMultiple: true,
              validation: null,
              showWhen: null,
            },
            {
              id: "idNumber",
              label: "ID Number",
              type: "text",
              placeholder: "Enter your ID number",
              required: true,
              isDisabled: false,
              isMultiple: false,
              validation: null,
              showWhen: null,
            },
            {
              id: "idPicture",
              label: "ID Picture",
              isDisabled: false,
              required: true,
              validation: {
                maxSize: 2,
                message: "File size should not exceed 2MB",
              },
              accept: "image/*",
              type: "file",
              isMultiple: false,
              showWhen: null,
            },
            {
              id: "profilePicture",
              label: "Your Picture",
              type: "file",
              required: true,
              accept: "image/*",
              maxSize: 2,
              helpText: "Upload a recent photo of yourself (max 2MB)",
              isDisabled: false,
              isMultiple: false,
              validation: null,
              showWhen: null,
            },
            {
              id: "tshirtSize",
              label: "T-shirt Size",
              type: "select",
              required: true,
              options: [
                { value: "xs", label: "XS" },
                { value: "s", label: "S" },
                { value: "m", label: "M" },
                { value: "l", label: "L" },
                { value: "xl", label: "XL" },
                { value: "xxl", label: "XXL" },
              ],
              isDisabled: false,
              isMultiple: true,
              validation: null,
              showWhen: null,
            },
            {
              id: "travelUpdatePreference",
              label: "Travel Details Update Preference",
              type: "radio",
              required: true,
              options: [
                { value: "now", label: "Update Now" },
                { value: "later", label: "Update Later" },
              ],
              conditionalFields: "travelUpdateNow",
              isDisabled: false,
              isMultiple: true,
              validation: null,
              showWhen: null,
            },
            {
              id: "travelUpdateNow",
              dependsOn: {
                field: "travelUpdatePreference",
                value: "now",
              },
              fields: [
                {
                  id: "airline",
                  label: "Flight: Airline Name",
                  type: "text",
                  placeholder: "Enter airline name",
                  required: true,
                  isDisabled: false,
                  isMultiple: false,
                  validation: null,
                  showWhen: null,
                },
                {
                  id: "flightNumber",
                  label: "Flight: Flight Number",
                  type: "text",
                  placeholder: "Enter flight number",
                  required: true,
                  isDisabled: false,
                  isMultiple: false,
                  validation: null,
                  showWhen: null,
                },
                {
                  id: "arrivalDateTime",
                  label: "Flight: Arrival Date & Time",
                  type: "datetime-local",
                  required: true,
                  isDisabled: false,
                  isMultiple: false,
                  validation: null,
                  placeholder: null,
                  showWhen: null,
                },
                {
                  id: "departureCity",
                  label: "Flight: Coming From",
                  type: "text",
                  placeholder: "Enter departure city",
                  required: true,
                  isDisabled: false,
                  isMultiple: false,
                  validation: null,
                  showWhen: null,
                },
                {
                  id: "transportOption",
                  label: "Transport Option",
                  type: "radio",
                  required: true,
                  options: [
                    { value: "airportPickup", label: "Airport Pick-up" },
                    { value: "ownTransport", label: "Own Transport" },
                    { value: "cityPickup", label: "City Pickup" },
                  ],
                  conditionalFields: "transportDetails",
                  isDisabled: false,
                  isMultiple: true,
                  validation: null,
                  showWhen: null,
                },
                {
                  id: "transportDetails",
                  dependsOn: {
                    field: "transportOption",
                  },
                  fields: [
                    {
                      id: "airportPickupTime",
                      label: "Airport Pick-up Time",
                      isDisabled: false,
                      isMultiple: false,
                      required: true,
                      validation: null,
                      placeholder: null,
                      showWhen: "airportPickup",
                      type: "time",
                    },
                    {
                      id: "ownTransportCheckInTime",
                      label: "Own Transport: Check-in Time",
                      type: "time",
                      required: true,
                      isDisabled: false,
                      isMultiple: false,
                      validation: null,
                      showWhen: "ownTransport",
                    },
                    {
                      id: "ownTransportCheckInLocation",
                      label: "Own Transport: Check-in Location",
                      type: "text",
                      required: true,
                      placeholder: "Enter check-in location",
                      isDisabled: false,
                      isMultiple: false,
                      validation: null,
                      showWhen: "ownTransport",
                    },
                    {
                      id: "cityPickupTime",
                      label: "City Pickup: Time",
                      type: "time",
                      required: true,
                      isDisabled: false,
                      isMultiple: false,
                      validation: null,
                      showWhen: "cityPickup",
                    },
                    {
                      id: "cityPickupLocation",
                      label: "City Pickup: Location",
                      type: "text",
                      required: true,
                      placeholder: "Enter pickup location",
                      isDisabled: false,
                      isMultiple: false,
                      validation: null,
                      showWhen: "cityPickup",
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          id: "invoiceDetails",
          title: "Invoice Details",
          fields: [
            {
              id: "invoiceName",
              label: "Name for Invoice",
              type: "text",
              placeholder: "Enter name for invoice",
              required: true,
              isDisabled: false,
              isMultiple: false,
              validation: null,
              showWhen: null,
            },
            {
              id: "invoiceEmail",
              label: "Email Address for Invoice",
              type: "email",
              placeholder: "Enter email address for invoice",
              required: true,
              validation: {
                pattern: "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$",
                message: "Please enter a valid email address",
              },
              isDisabled: false,
              isMultiple: false,
              showWhen: null,
            },
            {
              id: "invoiceAddress",
              label: "Address for Invoice",
              type: "textarea",
              placeholder: "Enter address for invoice",
              required: true,
              rows: 3,
              isDisabled: false,
              isMultiple: false,
              validation: null,
              showWhen: null,
            },
            {
              id: "hasTDS",
              label: "TDS Applicable",
              type: "radio",
              required: true,
              options: [
                { value: "yes", label: "Yes" },
                { value: "no", label: "No" },
              ],
              conditionalFields: ["gstTanSection"],
              isDisabled: false,
              isMultiple: true,
              validation: null,
              showWhen: null,
            },
            {
              id: "gstTanSection",
              dependsOn: {
                field: "hasTDS",
                value: "yes",
              },
              fields: [
                {
                  id: "isIndianGST",
                  label: "Registered under Indian GST",
                  type: "radio",
                  required: true,
                  options: [
                    { value: "yes", label: "Yes" },
                    { value: "no", label: "No" },
                  ],
                  conditionalFields: "gstDetails",
                  isDisabled: false,
                  isMultiple: true,
                  validation: null,
                  showWhen: null,
                },
                {
                  id: "gstDetails",
                  dependsOn: {
                    field: "isIndianGST",
                    value: "yes",
                  },
                  fields: [
                    {
                      id: "gstNumber",
                      label: "GST Number",
                      type: "text",
                      placeholder: "Enter GST number",
                      required: true,
                      validation: {
                        pattern:
                          "^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$",
                        message: "Please enter a valid GST number",
                      },
                      isDisabled: false,
                      isMultiple: false,
                      showWhen: null,
                    },
                  ],
                },
                {
                  id: "tanNumber",
                  label: "TAN Number",
                  type: "text",
                  placeholder: "Enter TAN number",
                  required: true,
                  validation: {
                    pattern: "^[A-Z]{4}[0-9]{5}[A-Z]{1}$",
                    message: "Please enter a valid TAN number",
                  },
                  isDisabled: false,
                  isMultiple: false,
                  showWhen: null,
                },
              ],
            },
            {
              id: "paymentMethod",
              label: "Payment Method",
              type: "radio",
              required: true,
              options: [
                { value: "creditCard", label: "Credit Card" },
                { value: "debitCard", label: "Debit Card" },
                { value: "netBanking", label: "Net Banking" },
                { value: "upi", label: "UPI" },
                { value: "cash", label: "Cash" },
              ],
              isDisabled: false,
              isMultiple: true,
              validation: null,
              showWhen: null,
            },
            {
              id: "amount",
              label: "Amount",
              type: "number",
              placeholder: "Enter amount",
              required: true,
              validation: {
                min: 0,
                message: "Amount cannot be negative",
              },
              isDisabled: false,
              isMultiple: false,
              showWhen: null,
            },
            {
              id: "handoverDate",
              label: "Handover Date",
              type: "date",
              required: true,
              isDisabled: false,
              isMultiple: false,
              validation: null,
              showWhen: null,
            },
            {
              id: "handoverTo",
              label: "Handover To",
              type: "text",
              placeholder: "Enter person name for handover",
              required: true,
              isDisabled: false,
              isMultiple: false,
              validation: null,
              showWhen: null,
            },
          ],
        },
      ],
    },
  ],
};

export const fieldTypes = [
  { value: "text", label: "Text Field" },
  { value: "email", label: "Email Field" },
  { value: "date", label: "Date Field" },
  { value: "textarea", label: "Paragraph" },
  { value: "select", label: "Dropdown" },
  { value: "radio", label: "Radio Button" },
  { value: "checkbox", label: "Checkbox" },
  { value: "boolean", label: "Yes/No" },
  { value: "file", label: "File Upload" },
  { value: "number", label: "Number Field" },
];

export const phoneNumberType = {
  differentNumber : "Family member's number",
  myPhoneNumber : "My phone number"
};

export const PhoneErrorMessages = {
  normal: "This mobile number already exists in our database. Please provide another mobile number to proceed with your registration.",
  restricted: "This number already exists in our database. If this is your family member’s number, please select ‘Family member’s number' and mention how you are related to them.",
}